import React from "react";
import PropTypes from "prop-types";
import SquaredTab from "./SquaredTab";
import "./SquaredTabs.scss";

const propTypes = {
  /**
   * Tabs that compose the component
   */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.node.isRequired,
      title: PropTypes.string,
      picture: PropTypes.string,
      status: PropTypes.string,
      content: PropTypes.node.isRequired,
      count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  /**
   * Initial selected tab
   */
  defaultTabSelectedIndex: PropTypes.number,
  /**
   * Callback on select tab
   */
  onTabSelect: PropTypes.func,
};

const defaultProps = {
  defaultTabSelectedIndex: 0,
  onTabSelect: () => {},
};

/**
 * @param {Object} tabs
 * @param {Object} defaultTabSelectedIndex the default tab selected index
 * @param {function} onSelect callback on tab get selected
 */
function SquaredTabs(props) {
  const { tabs, defaultTabSelectedIndex, onTabSelect } = props;

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(
    defaultTabSelectedIndex
  );

  return (
    <div>
      <div className="Uic-SquaredTabs-tabs">
        {tabs.map((tab, i) => (
          <SquaredTab
            key={i} // eslint-disable-line react/no-array-index-key
            label={tab?.label}
            title={tab?.title}
            disabled={tab?.disabled}
            picture={tab?.picture}
            status={tab?.status}
            isSelected={selectedTabIndex === i}
            count={tab?.count ? tab?.count?.toString() : "0"}
            onClick={(value) => {
              if (value) {
                setSelectedTabIndex(i);
                onTabSelect(tabs[i], i);
              }
            }}
          />
        ))}
      </div>
      <div>{tabs[selectedTabIndex]?.content}</div>
    </div>
  );
}

SquaredTabs.propTypes = propTypes;
SquaredTabs.defaultProps = defaultProps;

export default SquaredTabs;
